import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { motion, AnimatePresence } from "framer-motion";
import InputField from "../../common/InputField";
import Button from "../../common/Button";
import { DiePurchaseOrderAPI } from "../../utlis/apiService";
import { notify } from "../../common/Toast";

const DieInwardModal = ({ selectedItems, onClose, onSuccess }) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    const userId = user?.userId;
    const today = new Date().toISOString()?.split("T")[0];

    const [loading, setLoading] = useState(false);
    const [inwardData, setInwardData] = useState({
        inward_Date: today,
        invoice_No: "",
    });

    const handleInputChange = (field, value) => {
        setInwardData(prev => ({ ...prev, [field]: value }));
    };

    const handleInwardSubmit = async () => {
        if (!inwardData.invoice_No) {
            notify("Please enter Invoice/Challan Number", "warning");
            return;
        }

        setLoading(true);
        try {
            const payload = {
                trnNos: selectedItems.map(item => item.trn_No),
                inward_Date: inwardData.inward_Date,
                invoice_No: inwardData.invoice_No,
                created_By: userId
            };

            const res = await DiePurchaseOrderAPI.processInward(payload);
            if (res.success) {
                notify("Dies inwarded successfully", "success");
                onSuccess();
            } else {
                notify(res.message || "Failed to process inward", "error");
            }
        } catch (error) {
            notify("Server error while processing inward", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <AnimatePresence>
            <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm">
                <motion.div
                    initial={{ opacity: 0, scale: 0.95, y: 20 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.95, y: 20 }}
                    className="bg-white rounded-3xl  w-full max-w-2xl overflow-hidden border border-slate-100"
                >
                    {/* Header */}
                    <div className="bg-gradient-to-r from-blue-600 to-indigo-700 px-6 py-4 flex justify-between items-center">
                        <div className="flex items-center gap-3">
                            <div className="p-2 bg-white/10 rounded-xl backdrop-blur-md">
                                <HiOutlineCheckCircle className="text-white w-6 h-6" />
                            </div>
                            <div>
                                <h3 className="text-white font-bold text-lg leading-tight">Process Die Inward</h3>
                                <p className="text-blue-100 text-[10px] uppercase tracking-widest font-black">Finalize Receipt</p>
                            </div>
                        </div>
                        <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full text-white transition-colors">
                            <MdClose size={24} />
                        </button>
                    </div>

                    <div className="p-6">
                        {/* Summary of Items */}
                        <div className="mb-6 p-4 bg-slate-50 rounded-2xl border border-slate-100">
                            <div className="flex justify-between items-center mb-3">
                                <span className="text-sm font-bold text-slate-600">Selected Dies ({selectedItems.length})</span>
                                <span className="text-xs text-slate-400 font-medium italic">All selected dies will share the same inward info</span>
                            </div>
                            <div className="flex flex-wrap gap-2 max-h-32 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-slate-200">
                                {selectedItems.map((item, i) => (
                                    <div key={i} className="px-3 py-1.5 bg-white border border-slate-200 rounded-lg  flex items-center gap-2">
                                        <span className="w-2 h-2 rounded-full bg-blue-500"></span>
                                        <span className="text-xs font-bold text-slate-700">{item.dieNumber}</span>
                                        <span className="text-[10px] bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded font-mono">PO#{item.pO_No}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Inward Fields */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                            <InputField
                                label="Inward Date"
                                type="date"
                                value={inwardData.inward_Date}
                                onChange={(val) => handleInputChange("inward_Date", val)}
                            />
                            <InputField
                                label="Invoice / Challan No"
                                value={inwardData.invoice_No}
                                onChange={(val) => handleInputChange("invoice_No", val)}
                                placeholder="Enter reference number"
                            />
                        </div>

                        {/* Footer Actions */}
                        <div className="flex justify-end gap-3 pt-4 border-t border-slate-100 mt-4">
                            <button
                                onClick={onClose}
                                className="px-6 py-2.5 text-sm font-bold text-slate-500 hover:bg-slate-50 rounded-xl transition-all active:scale-95"
                            >
                                CANCEL
                            </button>
                            <Button
                                text={loading ? "Processing..." : `CONFIRM RECEIPT (${selectedItems.length} DIES)`}
                                className="bg-blue-600 text-white hover:bg-blue-700  -200 px-8 py-2.5 rounded-xl font-bold transition-all active:scale-95"
                                onClick={handleInwardSubmit}
                                disabled={loading}
                            />
                        </div>
                    </div>
                </motion.div>
            </div>
        </AnimatePresence>
    );
};

export default DieInwardModal;
